import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LeoSubscriptionsResponse } from '../../types/subscriptions';
import { SubscriptionsService } from './subscriptionsApi';

interface LeoSubscriptionsState {
    loading: boolean;
    requestStatus: 'default' | 'pending' | 'fulfilled' | 'rejected';
    message: string;
    data?: LeoSubscriptionsResponse;
}

const initialState: LeoSubscriptionsState = {
    loading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchLeoSubscriptions =
    createAsyncThunk<LeoSubscriptionsResponse>(
        'subscriptions/tryToFetchLeoSubscriptions',
        async () => {
            const result =
                await SubscriptionsService.tryToFetchLeoSubscriptions();
            return result.data;
        },
    );

export const subscriptionsSlice = createSlice({
    name: 'subscriptions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(tryToFetchLeoSubscriptions.pending, (state) => {
                state.loading = true;
                state.requestStatus = 'pending';
                state.message = '';
            })
            .addCase(tryToFetchLeoSubscriptions.rejected, (state, action) => {
                state.loading = false;
                state.requestStatus = 'rejected';
                state.message =
                    action.error.message || 'Unable to fetch subscriptions.';
            })
            .addCase(tryToFetchLeoSubscriptions.fulfilled, (state, action) => {
                state.loading = false;
                state.requestStatus = 'fulfilled';
                state.data = action.payload;
            });
    },
});

export default subscriptionsSlice.reducer;
